// @ts-nocheck
import React from "react";
import { compose } from "modules/core";
import { withApollo } from '@apollo/client/react/hoc';
import { KUDOS_MODULE_USAGE } from "modules/poc-dashboard/graphql/moduleusageQuery.gql";
import CommonTableView from "modules/poc-dashboard/components/common/tableView";
import { Capitalize, displayUtcToUserTimezone } from "modules/look";
import moment from "moment-timezone";
import { getOrgID } from "../../organization/organizationOperations";

const KudosModuleUsageContainer = (props) => {
    const { client, permission, date_range_filter, search, orgToFetchData } = props
    const [data_list_loading, setDataListLoading] = React.useState(false)
    const [list, SetList] = React.useState([])
    const [page_info, SetPageInfo] = React.useState()
    const list_ref = React.useRef([])

    React.useEffect(() => {
        list_ref.current = list
    }, [list])

    const header_list = [
        {
            label: "Employee Name"
        },
        {
            label: "Issued Badge"
        },
        {
            label: "Received badge"
        },
        {
            label: "Last Accessed Date"
        }
    ]
    React.useEffect(() => {
        if (permission?.required_permission && (orgToFetchData?.id || getOrgID(props))) {
            ModuleUsage({})
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [permission, orgToFetchData])

    React.useEffect(() => {
        ModuleUsage({})
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [date_range_filter])

    const timeout_ref = React.useRef()

    React.useEffect(() => {
        clearTimeout(timeout_ref.current)
        timeout_ref.current = setTimeout(() => {
            ModuleUsage({})
        }, 600)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search])

    const ModuleUsage = async (filter) => {
        setDataListLoading(true)
        let createdAt_Range = []
        if (date_range_filter && date_range_filter?.start_date && date_range_filter?.end_date) {
            let start_date = date_range_filter?.start_date
            let end_date = date_range_filter?.end_date
            createdAt_Range = [start_date, end_date]
        }
        else {
            createdAt_Range = []
        }

        const { data } = await client.query({
            query: KUDOS_MODULE_USAGE,
            variables: { ...filter, first: 10, createdAt_Range, user_FirstName: search, id: getOrgID(props) || orgToFetchData?.id },
            fetchPolicy: 'network-only'
        });
        if (data?.organizationById?.employees) {
            let list = data?.organizationById?.employees?.edges?.map(({ node }) => {
                let date = []
                if (node?.issued?.edges[0]?.node?.createdAt) {
                    date.push(node?.issued?.edges[0]?.node?.createdAt)
                }
                if (node?.received?.edges[0]?.node?.createdAt) {
                    date.push(node?.received?.edges[0]?.node?.createdAt)
                }

                if (date?.length) {
                    date = date?.sort((a, b) => moment(b).unix() - moment(a).unix())
                }

                let last_accessed = date?.length ? displayUtcToUserTimezone(moment(date[0]), 'DD/MM/YYYY') : "-"

                let row_data = [
                    {
                        type: "label",
                        value: `${Capitalize(node?.user?.firstName)} ${Capitalize(node?.user?.lastName) || ""}`
                    },
                    {
                        type: "label",
                        value: node?.issued?.totalCount
                    },
                    {
                        type: "label",
                        value: node?.received?.totalCount
                    },
                    {
                        type: "label",
                        value: last_accessed
                    }
                ]
                return row_data
            })
            if (filter?.after) {
                list = list_ref?.current?.concat(list)
            }
            SetList(list)
            SetPageInfo(data?.organizationById?.employees?.pageInfo)
            setDataListLoading(false)
        }
    }

    const onPagination = () => {
        if (page_info?.hasNextPage) {
            ModuleUsage({ after: page_info?.endCursor })
        }
    }

    return (
        <>
            <CommonTableView {...props} data_list_loading={data_list_loading} header_list={header_list} list={list} page_info={page_info} onPagination={onPagination} />
        </>
    )
}

export default compose(withApollo)(KudosModuleUsageContainer)